
define(
	'DataLayer'
	, [
		'underscore',
		'Utilities.ResizeImage',
		'Tracker',
		'Backbone',
		'GoogleTagManager',
		'GoogleTagManager.NavigationHelper.Plugins.Standard',
		'Item.Model',
		'LiveOrder.Model',
		'Profile.Model',
		'DataLayer.Model'
	]
	, function (
		_,
		resizeImage,
		Tracker,
		Backbone,
		GoogleTagManager,
		GTMNavigationHelperPluginsStandard,
		ItemModel,
		LiveOrderModel,
		ProfileModel,
		DataLayerModel
	) {
		'use strict';
		// constants required for the implementation
		var BASE_PRICE_FIELD, IMAGE_FIELD, BRAND_FIELD, DEFAULT_BRAND;
		function processGTMJS() {
			var profile = ProfileModel.ProfileModel && ProfileModel.ProfileModel.getInstance() || ProfileModel.getInstance();
			var userData, addresBook, countryName, regionName, shipAddr, phone,
				additionalAddress;
			var gtmjs = _.find(dataLayer, function (event) {
				return event.event === 'gtm.js';
			});
			var isLoggedIn = profile.get('isLoggedIn');
			if (gtmjs && isLoggedIn === 'T') {
				addresBook = profile.get('addressbook') || profile.get('addresses') && profile.get('addresses').models[0];

				if (addresBook instanceof Array) {
					shipAddr = _.find(addresBook, function (address) {
						return address.defaultshipping === 'T';
					});
				} else {
					addresBook = profile.get('addresses').models;
					shipAddr = _.find(addresBook, function (address) {
						return address.get('defaultshipping') == 'T';
					});
				}
				if (shipAddr) {
					countryName = (shipAddr.country !== undefined)
						? SC.ENVIRONMENT.siteSettings.countries[shipAddr.country].name
						: SC.ENVIRONMENT.siteSettings.countries[shipAddr.attributes.country].name;
					if (shipAddr.attributes.state || shipAddr.state) {
						regionName = (shipAddr.country !== undefined)
						? _.find(SC.ENVIRONMENT.siteSettings.countries[shipAddr.country].states, function (state) {
							return state.code === shipAddr.state;
						}).name
						: _.find(SC.ENVIRONMENT.siteSettings.countries[shipAddr.attributes.country].states, function (state) {
							return state.code === shipAddr.attributes.state;
						}).name;
					}
					phone = shipAddr.phone || shipAddr.attributes && shipAddr.attributes.phone;
					var additionalAddres2 = (shipAddr.addr2 !== undefined)
						? (shipAddr.addr2 === null ? '' : shipAddr.addr2)
						: (shipAddr.attributes && shipAddr.attributes.addr2 === null ? '' : shipAddr.attributes && shipAddr.attributes.addr2);
					var additionalAddres3 = (shipAddr.addr3 !== undefined)
						? (shipAddr.addr3 === null ? '' : shipAddr.addr3)
						: (shipAddr.attributes && shipAddr.attributes.addr3 === null ? '' : shipAddr.attributes && shipAddr.attributes.addr3);
					additionalAddress = additionalAddres2 + ' ' + additionalAddres3;
				}
				if (!phone && profile.get('phoneinfo')) {
					phone = profile.get('phoneinfo').phone || profile.get('phoneinfo').altphone;
				}
				userData = {
					profileId: profile.get('internalid'),
					firstName: profile.get('firstName') || profile.get('firstname'),
					lastName: profile.get('lastName') || profile.get('lastname'),
					email: profile.get('email'),
					// when in shopping, addressee and attention should be populated to get company from address
					companyName: shipAddr && shipAddr.attention && shipAddr.addressee ||
						// when in checkout and myaccount this is the attr for company from address
						shipAddr && shipAddr.company ||
						profile.get('companyname'),
					address: shipAddr && ((shipAddr.addr1 !== undefined) ? shipAddr.addr1 : shipAddr.attributes.addr1),
					city: shipAddr && ((shipAddr.city !== undefined) ? shipAddr.city : shipAddr.attributes.city),
					zip: shipAddr && ((shipAddr.zip !== undefined) ? shipAddr.zip : shipAddr.attributes.zip),
					regionCode: shipAddr && ((shipAddr.state !== undefined) ? shipAddr.state : shipAddr.attributes.state),
					countryCode: shipAddr && ((shipAddr.country !== undefined) ? shipAddr.country : shipAddr.attributes.country),
					country: countryName,
					region: regionName,
					addressAdditional: additionalAddress && additionalAddress.trim()
				};

				if (phone) {
					userData.phoneNumber = phone;
				}
				gtmjs.data = { user: userData, loggedIn: isLoggedIn === 'T' };
			} else {
				gtmjs.data = { loggedIn: isLoggedIn === 'T' };
			}
		}
		function searchInArray(items, value, recursive) {
			var foundVal = _.find(items, function(item) { return item.internalid == value});
			if (recursive && !window.parentItem) {
				window.parentItem = recursive;
			}

			if (!foundVal) {
				for (var i = 0; items.length > i; i++) {
					foundVal = searchInArray(items[i].categories, value, items[i]);
					if (foundVal) {
						break;
					}
				}
			}
			return foundVal;
		}
		function convertToItemObj(item, line) {
			var discount;
			var selectedOptions = line.get('options').filter(function (option) {
				return option.get('value') && option.get('value').label;
			});
			var price = line.get('rate') || item.getPrice() && item.getPrice().price;
			var itemIfMatrix = item.get('itemoptions_detail') && item.get('itemoptions_detail').matrixtype &&
				item.get('itemoptions_detail').matrixtype === 'child' && item.get('_matrixParent');
			var category = getCategoryObject(itemIfMatrix || item);
			var imageUrl = IMAGE_FIELD && item.get(IMAGE_FIELD) || item.get('_thumbnail') && item.get('_thumbnail').url;
			var basePrice = BASE_PRICE_FIELD && item.get(BASE_PRICE_FIELD);
			var brand = BRAND_FIELD && item.get(BRAND_FIELD) || item.get('manufacturer') || DEFAULT_BRAND;
			var resizedImage = imageUrl ? resizeImage(imageUrl, 'zoom') : '';
			var pathUrl = getItemURL(item, line);
			var itemVariants = _.map(selectedOptions, function (option) {
				return option.get('value').label;
			}).join(', ');
			var quantity = line.get('quantity') || item.get('quantityavailable') || 1;
			var amount = line.get('amount');

			if (line.getMatrixOptionsSelection && !_.isEmpty(line.getMatrixOptionsSelection())) {
				var matrixParentItem = line.get('item');
				pathUrl = getItemURL(matrixParentItem, line);
				resizedImage = matrixParentItem.get('_thumbnail') && matrixParentItem.get('_thumbnail').url &&
					resizeImage(matrixParentItem.get('_thumbnail').url, 'zoom');
				category = getCategoryObject(matrixParentItem);

				if (!basePrice) {
					basePrice = BASE_PRICE_FIELD && matrixParentItem.get(BASE_PRICE_FIELD);
				}
			}
			if (brand === '&nbsp;' || brand === '') {
				brand = DEFAULT_BRAND;
			}

			// discount is being wrongly calculated, if the basePrice is lower than the price then discount should be 0
			if (basePrice && basePrice < price)  discount = 0;
			else discount = Math.abs(basePrice - price);

			if (Number.isNaN(discount)) {
				discount = 0;
			} else {
				discount = parseFloat(discount.toFixed(2));
			}
			var retVal = {
				name: item.get('_name'),
				sku: item.get('itemid'),
				id: item.get('itemid'),
				price: (price) ? parseFloat(price.toFixed(2)) : 0,
				discount: discount > 0 ? discount : 0,
				variant: itemVariants,
				url: pathUrl,
				quantity: quantity,
				categoryNames: category.categoriesName,
				imageUrl: resizedImage,
				brand: brand,
				affiliation: brand,
				basePrice: basePrice || price,
				category: category.primaryCategoryUrl
			};
			var i = 1;
			_.each(category.categoriesName, function(categ) {
				if (i === 1 && !retVal['itemCategory']) {
					retVal['itemCategory'] = categ;
				} else if (i <= category.categoriesName.length) {
					retVal['itemCategory'+i] = categ;
				}
				i++;
			});
			if (amount) {
				retVal.amount = amount;
			}
			if (item.get('track_productlist_position')) {
				retVal.index = item.get('index');
				retVal.position = item.get('track_productlist_position');
				retVal.category = item.get('track_productlist_category');
				retVal.list = item.get('track_productlist_list');
				var listId = retVal.list.split(' ').join('_').toLowerCase();
				retVal.listId = listId;
			}
			return retVal;
		}
		function getItemURL(item, line) {
			var retVal;
			var quantity = line.get('quantity');
			var itemUrlPath = item.get('_url');
			var originUrl = Backbone.history.location.origin;
			var itemOptionsUrl = '';

			if (line.get('options')) {
				itemOptionsUrl = quantity ? '&' : '?';
			}
			line.get('options').models.forEach(function (itemOption) {
				if (itemOption.get('value')) {
					itemOptionsUrl += itemOption.get('urlParameterName') + '=' + encodeURIComponent(itemOption.get('value').internalid) + '&';
				}
			});
			if (itemOptionsUrl) {
				itemOptionsUrl = itemOptionsUrl.slice(0, -1);
			}
			retVal = originUrl + itemUrlPath + (quantity ? '?quantity=' + quantity.toString() : '') + itemOptionsUrl;
			return retVal;
		}
		function getCategoryObject(item) {
			// field should be in website record (in all fieldsets)
			var categoryPath = item.get('commercecategory');
			var categoryNamesData = [];
			var primaryPath = categoryPath && categoryPath.primarypath;
			var primaryCategoryUrl;
			if (primaryPath && primaryPath.length > 0) {
				primaryPath.forEach(function (category) {
					categoryNamesData.push(category.name)
				});
				primaryCategoryUrl = primaryPath && primaryPath[0] && primaryPath[0].urls[0];
			} else {
				primaryCategoryUrl = categoryPath && categoryPath.categories && categoryPath.categories[0] &&
					categoryPath.categories[0].urls[0];
				if (categoryPath && categoryPath.categories && categoryPath.categories.length) {
					var splittedCategories = categoryPath.categories[0].urls[0].split('/');
					_.each(splittedCategories,function(categ) {
						var charToFormat = categ.indexOf('-')>0 ? '-' : '_';
						var categoryNameFormatted = categ.split(charToFormat).map(function (word) {
							return word.charAt(0).toUpperCase() + word.slice(1);
						});
						categoryNameFormatted = categoryNameFormatted.join(' ');
						categoryNameFormatted && categoryNamesData.push(categoryNameFormatted);
					})
				}
			}
			return {
				primaryCategoryUrl: primaryCategoryUrl,
				categoriesName: categoryNamesData
			};
		}
		function setCartId(orderModel) {
			!localStorage.getItem('proceedToCheckoutUniqueId') && localStorage.setItem(
				'proceedToCheckoutUniqueId',
				orderModel.operationIds && orderModel.operationIds[0].split('-').join('') + '_' + new Date().getTime().toString()
			);
		}
		function getQuantityItemsId(internalId, linesLength) {
			var retVal;
			for (var i = 0; i < linesLength; i++) {
				var itemInternalId = internalId + '-' + i;
				if (typeof window.quantityItems[itemInternalId] !== 'undefined') {
					retVal = itemInternalId;
				}
			}

			return retVal;
		}
		function functionAddToCart(eventName, self, line, cartTotal, lengthToFixed, itemCounter) {
			var isPDPFull = jQuery('#ProductDetails\\.Full\\.View').length;
			var isPDPQuick = jQuery('#modal-ProductDetails\\.QuickView\\.View').length;
			var checkoutUrl = window.location.origin + SC.ENVIRONMENT.siteSettings.touchpoints.checkout;
			if (line) {
				var orderModel = LiveOrderModel.getInstance();
				var items = orderModel.attributes.lines.models;
				var eventData = {
					event: eventName ? 'addToCart' : 'removeFromCart',
					ecommerce: {
						currencyCode: (SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code) ||
                        	SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl || ''
					},
					data: {
						items: [],
						total: 0
					}
				};

				if (eventName) {
					eventData.ecommerce.add = { products: [] };
				} else {
					eventData.ecommerce.remove = { products: [] };
				}

				items.forEach(function (line) {
					var item = line.get('item'), objectItem;
					var amount = line.get('amount');
					cartTotal += amount;
					var stringAmount = amount.toString().split('.')[1];
					if (stringAmount && stringAmount.length > lengthToFixed) {
						lengthToFixed = 3
					}

					if (line.collection.length === itemCounter) {
						eventData.data.total = parseFloat(cartTotal.toFixed(lengthToFixed));
					}

					eventData.data.checkoutUrl = checkoutUrl;
					objectItem = convertToItemObj(item, line);
					if (window.isQuickAdd) {
						objectItem.listName = 'Quick Add';
						objectItem.listId = 'quick_add';
					} else {
						var result = self.findCategoryAndListInDataLayer(line);
						var resultListId = result.list.split(' ').join('_').toLowerCase();
						if (resultListId !== '') {
							objectItem.listName = result.list;
							objectItem.listId = resultListId;
						}
					}
					
					if (eventName) {
						var datalayerStorage = JSON.parse(localStorage.getItem('datalayer'));
						// line id is not great, always changing. we have to use a "internal way" to get
						// items id + options selected. SKU should work!!
						// if (self.getCategory().indexOf('cart') > -1 &&
						if (datalayerStorage.cartListRelationship && 
							datalayerStorage.cartListRelationship[line.get('internalid')]
						) {
							objectItem.listId = datalayerStorage.cartListRelationship[line.get('internalid')].listId;
							objectItem.listName = datalayerStorage.cartListRelationship[line.get('internalid')].listName;
						} else {
							objectItem.listId = objectItem.listId || datalayerStorage.lastListSeen.listId;
							objectItem.listName = objectItem.listName || datalayerStorage.lastListSeen.listName;
							if (!datalayerStorage.cartListRelationship) datalayerStorage.cartListRelationship = {};
							datalayerStorage.cartListRelationship[line.get('internalid')] = {
								listId: objectItem.listId,
								listName: objectItem.listName
							};
							localStorage.setItem('datalayer', JSON.stringify(datalayerStorage));
						}
					}
					eventData.data.items.push(objectItem);

					if (line.toProcess) {
						var newObjectItem;
						if (window.itemQuantity && (isPDPFull || isPDPQuick)) {
							var amountAux = objectItem.quantity * objectItem.price;
							var currentQuantity = window.itemQuantity;
							newObjectItem = JSON.parse(JSON.stringify(objectItem));
							newObjectItem.quantity = currentQuantity;
							newObjectItem.amount = parseFloat(amountAux.toFixed(2));
							var index = newObjectItem.url.lastIndexOf('=');
							newObjectItem.url = newObjectItem.url.slice(0, index + 1) + newObjectItem.quantity;

						} else {
							var saveItem = _.find(window.cartLinesBefore, function (value) {
								return value.get('item').id == item.id;
							});
							if (saveItem) {
								var amountAux = objectItem.quantity * objectItem.price;
								newObjectItem = JSON.parse(JSON.stringify(objectItem));
								newObjectItem.quantity = Math.abs(objectItem.quantity - saveItem._previousAttributes.quantity);
								newObjectItem.amount = parseFloat(amountAux.toFixed(2));
							} else {
								newObjectItem = objectItem;
							}
						}
						if (eventName) {
							eventData.ecommerce.add.value = parseFloat(newObjectItem.amount.toFixed(2));
						} else {
							eventData.ecommerce.remove.value = parseFloat(newObjectItem.amount.toFixed(2));
						}
						eventName ? eventData.ecommerce.add.products.push(newObjectItem) : eventData.ecommerce.remove.products.push(newObjectItem);
						line.toProcess = false;
					}
					itemCounter++;
				});
			}
			Tracker.trigger(eventName, eventData, line);
			self.pushData(eventData);
		}
		function setValuesUpdated(line, eventData, eventName, cartTotal, lengthToFixed, itemCounter, itemRemoved, pdp) {
			var isPDPFull = jQuery('#ProductDetails\\.Full\\.View').length;
			var isPDPQuick = jQuery('#modal-ProductDetails\\.QuickView\\.View').length;
			var item = line.get('item'), objectItem;
			var checkoutUrl = window.location.origin + SC.ENVIRONMENT.siteSettings.touchpoints.checkout;
			var amount = line.get('amount');
			var stringAmount = amount.toString().split('.')[1];
			if (eventName) {
				eventData.ecommerce.add = eventData.ecommerce.add || { products: [] };
			} else {
				eventData.ecommerce.remove = eventData.ecommerce.remove || { products: [] };
			}

			cartTotal += amount;
			if (stringAmount && stringAmount.length > lengthToFixed) {
				lengthToFixed = 3;
			}
			if (line.collection.length === itemCounter) {
				eventData.data.total = parseFloat(cartTotal.toFixed(lengthToFixed));
			}

			eventData.data.checkoutUrl = checkoutUrl;
			//Items data 
			objectItem = convertToItemObj(item, line);
			
			//----
			var datalayerStorage = JSON.parse(localStorage.getItem('datalayer'));
			// line id is not great, always changing. we have to use a "internal way" to get
			// items id + options selected. SKU should work!!
			// if (self.getCategory().indexOf('cart') > -1 &&
			if (datalayerStorage.cartListRelationship && 
				datalayerStorage.cartListRelationship[line.get('internalid')]
			) {
				objectItem.listId = datalayerStorage.cartListRelationship[line.get('internalid')].listId;
				objectItem.listName = datalayerStorage.cartListRelationship[line.get('internalid')].listName;
			} else {
				objectItem.listId = objectItem.listId || datalayerStorage.lastListSeen.listId;
				objectItem.listName = objectItem.listName || datalayerStorage.lastListSeen.listName;
				if (!datalayerStorage.cartListRelationship) datalayerStorage.cartListRelationship = {};
				datalayerStorage.cartListRelationship[line.get('internalid')] = {
					listId: objectItem.listId,
					listName: objectItem.listName
				};
				localStorage.setItem('datalayer', JSON.stringify(datalayerStorage));
			}
			//----
			eventData.data.items.push(objectItem);

			if (line.toProcess) {
				if (itemRemoved) {
					eventData.ecommerce.remove.products.push(itemRemoved);
				}
				//Update quantity
				var newObjectItem;
				if (window.itemQuantity && (isPDPFull || isPDPQuick)) {
					var currentQuantity = window.itemQuantity;
					var amountAux = objectItem.quantity * objectItem.price;
					newObjectItem = JSON.parse(JSON.stringify(objectItem));
					newObjectItem.quantity = currentQuantity;
					newObjectItem.amount = parseFloat(amountAux.toFixed(2));
					var index = newObjectItem.url.lastIndexOf('=');
					newObjectItem.url = newObjectItem.url.slice(0, index + 1) + newObjectItem.quantity;
				} else {
					var saveItem = _.find(window.cartLinesBefore, function (value) {
						return value.get('item').id == item.id;
					});
					if (saveItem) {
						var amountAux = objectItem.quantity * objectItem.price;
						newObjectItem = JSON.parse(JSON.stringify(objectItem));
						newObjectItem.quantity = Math.abs(objectItem.quantity - saveItem._previousAttributes.quantity);
						newObjectItem.amount = parseFloat(amountAux.toFixed(2));
					} else {
						newObjectItem = objectItem;
					}
				}
				if (eventName) {
					eventData.ecommerce.add.value = parseFloat(newObjectItem.amount.toFixed(2));
				} else {
					eventData.ecommerce.remove.value = parseFloat(newObjectItem.amount.toFixed(2));
				}
				eventName ? eventData.ecommerce.add.products.push(newObjectItem) : eventData.ecommerce.remove.products.push(newObjectItem);
				line.toProcess = false;
			}
			itemCounter++;
			return cartTotal;
		}
		function pushPageViewEvent(url, name, group, self) {
			var eventData = {
				event: 'pageView',
				data: {
					page: url,
					url: Backbone.history.location.origin + url,
					group: group,
					title: (name && name !== '' && url !== '/') ? name : 
						document.title ? document.title : 
						SC.Application.layout && SC.Application.layout.currentView && SC.Application.layout.currentView.title
				}
			};

			Tracker.trigger('pageView', eventData, url);
			self.pushData(eventData);
		}
		function storeLastSeen(listId, listName) {
			var dataLayerRaw = localStorage.getItem('datalayer');
			if (!dataLayerRaw || dataLayerRaw.length === 0) dataLayerRaw = '{}';
			var datalayerStorage = JSON.parse(dataLayerRaw);
			if (!datalayerStorage.lastListSeen) datalayerStorage.lastListSeen = {};
			datalayerStorage.lastListSeen.listName = listName;
			datalayerStorage.lastListSeen.listId = listId;
			localStorage.setItem('datalayer', JSON.stringify(datalayerStorage));
		}

		function updateProductListItems(items, eventData, listname, self) {
			_.each(items.models, function (item, index) {
				// Ignore items without id, to prevent tracking "things" that are not items.
				if (item.id) {
					item.set('track_productlist_position', index + 1);
					item.set('index', index);
					item.set('track_productlist_category', self.getCategory());
					item.set('track_productlist_list', listname);				
					var obj = convertToItemObj(item, item);
					obj.quantity = item.get('minimumquantity') || 1;
					// revamp of quantity, this should be MINIMUM required to buy.
					eventData.ecommerce.impressions.push(obj);
				}				
			});
		}

		return {
			convertToItemObj: convertToItemObj,
			mountToApp: function mountToApp(container) {
				var cart = container.getComponent("Cart");
				var environment = container.getComponent('Environment');
				var plp = container.getComponent('PLP');
				var pdp = container.getComponent('PDP');
				var CMS;

				Backbone.on('cms:loaded', function(cms) {
					CMS = cms;
				});

				BASE_PRICE_FIELD = environment && (environment.getConfig('dataLayer.basePriceField') || environment.getConfig('priceLevel.default'));
				DEFAULT_BRAND = environment && (environment.getConfig('dataLayer.defaultBrand') || environment.getSiteSetting('displayname'));
				BRAND_FIELD = environment && environment.getConfig('dataLayer.brandField');

				if (!localStorage.getItem('datalayer')) {
					localStorage.setItem('datalayer', JSON.stringify({
						lastListSeen: {
							listId: '',
							listName: ''
						},
						cartListRelationship: {}
					}));
				}

				GoogleTagManager.pushData = _.wrap(GoogleTagManager.pushData,
					function wrapPushDataFunction(fn) {
						fn.apply(this, _.toArray(arguments).slice(1));
						processGTMJS();
						var gtmjs = _.find(dataLayer, function (event) {
							return event.event === 'gtm.js';
						});
						if (gtmjs && gtmjs.data && gtmjs.data.user) {
							var model = new DataLayerModel();
							model.fetch({
								data: {
									customerid: gtmjs.data.user.profileId,
									email: gtmjs.data.user.email
								}
							}).done(function (result) {
								if (result) {
									gtmjs.data.user.contactId = result.contact_id;
									gtmjs.data.user.customerId = result.customer_id;
									gtmjs.data.user.userId = result.user_id;
									gtmjs.data.user.contactExtId = result.contact_ext_id;
									gtmjs.data.user.customerExtId = result.customer_ext_id;
									gtmjs.data.user.isinactive = result.isinactive;
									gtmjs.data.user.isperson = result.isperson;
									gtmjs.data.user.cseg_dhi_sales_chan = result.cseg_dhi_sales_chan;
									gtmjs.data.user.weblead = result.weblead;
									gtmjs.data.user.leadstatus = result.leadstatus;
								}
							})
						}
					}
				);

				GTMNavigationHelperPluginsStandard.mouseDownNavigation = function(_layout, e) {
					var $item = jQuery(e.currentTarget).closest('[data-track-productlist-category]');
					var itemModel = new ItemModel();
					
					if ($item.length) {
						itemModel.fetch({
							data: {
								id: $item.data('item-id'),
								fieldset: 'search'
							}
						}).done(function () {
							itemModel.set('list', $item.data('track-productlist-list'));
							itemModel.set('position', $item.data('track-productlist-position'));
							
							Tracker.getInstance().trackProductClick(itemModel);
						});
					}
					return e;
				};

				_.extend(GoogleTagManager, {

					trackProductClick: function(item) {
						var eventName = 'productClick';
						var listName = item.get('list');
						var listId;
						if (plp.current_view) {
							listId = plp.getCategoryInfo() ? plp.getCategoryInfo().urlfragment : 'search_results';
							if (listName === 'Category' && !plp.getCategoryInfo()) {
								listName = 'Search Results';
							}
						} else {
							listId = listName.split(' ').join('_').toLowerCase();
						}
						// List Id should always have _
						listId = listId.split('-').join('_');

						if (listName === 'Related Items' || listName === 'Correlated Items' || listName === 'Recently Viewed Items') {
							// this click came from an item, so it's important to follow this :)
							storeLastSeen(listId, listName);
						}

						if (!listName) {
							listName = listId.split('_').map(function (word) {
								return word.charAt(0).toUpperCase() + word.slice(1);
							});
							listName = listName.join(' ');
						}

						var itemObj = convertToItemObj(item, item);
						itemObj.quantity = item.get('minimumquantity') || 1;
						itemObj.position = 1;
						itemObj.index = 0;
						itemObj.listId = listId;
						itemObj.listName = listName;
						itemObj.list = listName;

						var eventData = {
							event: eventName,
							ecommerce: {
								click: {
									actionField: {
										action: 'click',
										list: listName
									},
									listId: listId,
									listName: listName,
									products: [
										itemObj
									]
								}
							}
						};
						this.item = item;
						this.pushData(eventData);
						Tracker.trigger(eventName, eventData, item);
						return this;
					},

					trackProductView: function (product) {
						var item = product.getItem();
						var eventName = 'productView';
						var result = this.findCategoryAndListInDataLayer(product);
						var objectItem = convertToItemObj(item, product);
						objectItem.quantity = item.get('minimumquantity') || 1;
						var datalayerStorage = JSON.parse(localStorage.getItem('datalayer'));
						objectItem.listId = datalayerStorage.lastListSeen.listId;
						objectItem.listName = datalayerStorage.lastListSeen.listName;
						var resultListId = result.list.split(' ').join('_').toLowerCase();
						var commercecategory = product.get('item').get('commercecategory');
						if (resultListId === '') {
							if (commercecategory.categories && commercecategory.categories.length) {
								var foundLastSeenInProduct = commercecategory.categories.find(function (category) {
									return category.name === objectItem.listName;
								});
								if (!foundLastSeenInProduct) {
									foundLastSeenInProduct = commercecategory.categories[0];
									objectItem.listName = foundLastSeenInProduct.name;
									var urlCategs = foundLastSeenInProduct.urls[0].split('/');
									objectItem.listId = urlCategs[urlCategs.length - 1];
								}
							} else {
								objectItem.listName = 'Search Results';
								objectItem.listId = 'search_results';
							}
						} else {
							objectItem.listName = result.list;
							objectItem.listId = resultListId;
						}
						
						objectItem.position = 1;
						objectItem.index = 0;
						objectItem.list = objectItem.listName;

						var eventData = {
							event: eventName,
							ecommerce: {
								detail: {
									currencyCode: (SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code) ||
										SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl || '',
									value: objectItem.price * objectItem.quantity,
									actionField: {
										list: objectItem.listName
									},
									products: [
										objectItem
									]
								}
							},
							page: this.getCategory()

						};
						this.item = null;

						Tracker.trigger(eventName, eventData, item);
						this.pushData(eventData);

						return this;
					},
					trackPageviewForCart: function (lines) {
						if (lines) {
							window.cartLines = {};
							var itemCounter = 1;
							var items = lines.items ? lines.items.models : LiveOrderModel.getInstance().get('lines').models;
							var lengthToFixed = 2;
							var total = 0;
							var eventName = 'cartView';
							var eventData = {
								event: eventName,
								data: {
									total: 0,
									page: '',
									items: [],
									currencyCode: (SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code) ||
										SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl || ''
								}
							};

							window.cartLines = items;
							var quantityObj = {};
							var datalayerStorage = JSON.parse(localStorage.getItem('datalayer'));
							items.forEach(function (line) {
								var item = line.get('item'), objectItem;
								var checkoutUrl = window.location.origin + SC.ENVIRONMENT.siteSettings.touchpoints.checkout;
								var quantity = line.get('quantity');
								//Olds Quantity By Event
								var positionInternalId = item.id + '-' + (itemCounter - 1);
								var amount = line.get('amount');
								if (!amount) { // WA when the user adds an item and go to the cart too fast.
									var rate = line.get('rate_formatted');
									rate = parseFloat(rate.replace(/\$/g, ''));
									amount = rate * quantity;
								}
								var stringAmount = amount.toString().split('.')[1];
								quantityObj[positionInternalId] = quantity;
								total += amount;
								
								if (stringAmount && stringAmount.length > lengthToFixed) {
									lengthToFixed = 3;
								}

								if (line.collection.length === itemCounter) {
									eventData.data.total = parseFloat(total.toFixed(lengthToFixed));
								}

								eventData.data.checkoutUrl = checkoutUrl;
								eventData.data.page = lines.url;
								objectItem = convertToItemObj(item, line);
								objectItem.image = objectItem.imageUrl;
								objectItem.title = objectItem.name;
								if (datalayerStorage.cartListRelationship[line.get('internalid')]) {
									objectItem.listId = datalayerStorage.cartListRelationship[line.get('internalid')].listId;
									objectItem.listName = datalayerStorage.cartListRelationship[line.get('internalid')].listName;
								}
								eventData.data.items.push(objectItem);
								itemCounter++;
							});
							window.quantityItems = quantityObj;
							Tracker.trigger(eventName, eventData);
							this.pushData(eventData);
						}
						return this;
					},
					trackRemoveFromCart: function(line, quantity) {
						// new Feature from sc 2023.2, not used in our solution.
					},
					trackAddToCartSpecificQuantity: function (line, quantity) {
						// a duplicate bug from sc 2023.2
						if (!line.id) {
							return;
						}
						window.cartLines = window.cartLines || {};
						var fromCart = Backbone.history.location.href.indexOf('cart') !== -1;
						var lengthToFixed = 2;
						var itemCounter = 1;
						var cartTotal = 0;
						var eventName = true;
						var notFoundLine = true;
						var index = 0;
						var self = this;
						if (fromCart) {
							cart.getLines().then(function (lines) {
								if (window.quantityItems && lines) {
									//Serching the position of the item modified
									while (index < lines.length && notFoundLine) {
										if (lines[index].item.internalid === line.get('item').id) {
											var itemInternalId = lines[index].item.internalid + '-' + index;
											// var itemCartQuantity = line.get('quantity');
											var itemCartQuantity = quantity;

											if (typeof window.quantityItems[itemInternalId] === 'undefined') {
												itemInternalId = getQuantityItemsId(line.get('item').id, lines.length);
											}
											line.toProcess = true;
											if (window.quantityItems[itemInternalId] > itemCartQuantity) {
												eventName = false;
											} else {
												eventName = true;
											}
											window.quantityItems[itemInternalId] = itemCartQuantity;
											notFoundLine = false;
										}
										index++;
									}
									functionAddToCart(eventName, self, line, cartTotal, lengthToFixed, itemCounter);
								}
							});
						} else {
							line.toProcess = true;
							functionAddToCart(eventName, self, line, cartTotal, lengthToFixed, itemCounter);
						}
						return this;
					},
					trackAddToCart: function (line) {
						// from 2023.2 this changed, so we now require changes in trackAddToCartSpecificQuantity instead of trackAddToCart
						this.trackAddToCartSpecificQuantity(line, line.get('quantity'));
					},
					trackCartUpdate: function (items, removeTriggered, lineToSearch) {
						var fromCart = Backbone.history.location.href.indexOf('cart') !== -1;
						var cartTotal = 0;
						var lengthToFixed = 2;
						var itemCounter = 1;
						var eventName = items && items.line_id ? false : true;
						var eventNameText = 'cartItemsUpdate';
						var notFoundLine = true;
						var index = 0;
						var self = this;
						var itemRemoved;

						if (items) {
							var eventData = {
								event: 'cartItemsUpdate',
								data: {
									items: [],
									total: 0
								},
								ecommerce: {
									currencyCode: (SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code) ||
										SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl || ''
								}
							};

							if (removeTriggered) {
								if (window.cartLines && window.cartLines.length > 0 && items.line_id) {
									var cartLines = window.cartLines;
									var lineFound = false;
									var index = 0;
									while (index < cartLines.length && !lineFound) {
										var itemIternalId = lineToSearch || items.line_id;
										if (itemIternalId.indexOf(cartLines[index].get('internalid')) > -1) {

											itemRemoved = convertToItemObj(cartLines[index].get('item'), cartLines[index]);
											lineFound = true;
										}
										index++;
									}
								}
							}

							//From Cart there are not ITEMS and When remove function was called
							var orderModel = LiveOrderModel.getInstance();
							if (!items.length) {
								var itemList = orderModel.get('lines').models;
								if (itemRemoved) {
									eventData.ecommerce.remove = { products: [itemRemoved] };
									eventData.ecommerce.remove.value = parseFloat(itemRemoved.amount.toFixed(2));
									if (itemList.length === 0) {
										Tracker.trigger(eventNameText, eventData);
										self.pushData(eventData);
										var event2CartEmpty = Object.assign({}, eventData);
										event2CartEmpty['gtm.uniqueEventId'] = ++event2CartEmpty['gtm.uniqueEventId'];

										event2CartEmpty.event = 'removeFromCart';
										Tracker.trigger('removeFromCart', event2CartEmpty);
										self.pushData(event2CartEmpty);
										return this;
									}
								}

								itemList.forEach(function (line) {
									//Logic for removeFromCart function
									if (fromCart) {
										if (window.quantityItems) {
											//Serching the position of the item modified
											if (!removeTriggered) {
												while (index < itemList.length && notFoundLine) {
													if (lineToSearch && itemList[index].get('item').get('internalid') === lineToSearch
														|| itemList[index].get('item').get('internalid') === items.line.item.internalid) {
														var itemInternalId = itemList[index].get('item').get('internalid') + '-' + index;
														var itemCartQuantity = items.line.quantity;

														if (typeof window.quantityItems[itemInternalId] === 'undefined') {
															itemInternalId = getQuantityItemsId(
																itemList[index].get('item').get('internalid'),
																itemList.length
															);
														}

														if (window.quantityItems[itemInternalId] > itemCartQuantity) {
															eventName = false;
														} else {
															eventName = true;
														}
														itemList[index].toProcess = true;
														notFoundLine = false;
													}
													index++;
												}
											} else {
												eventName = false;
											}
										}
									}
									cartTotal = setValuesUpdated(line, eventData, eventName, cartTotal, lengthToFixed, itemCounter, itemRemoved, pdp);
									itemCounter++;
								});
								window.cartLines = itemList;

							} else {
								//This logic run when you are NOT on the CART-VIEW	
								items.forEach(function (line, it) {
									if (!it) {
										line.toProcess = true;
									}
									cartTotal = setValuesUpdated(line, eventData, eventName, cartTotal, lengthToFixed, itemCounter, itemRemoved, pdp);
								});
							}

							eventData.data.total = cartTotal && parseFloat(cartTotal.toFixed(2)) || 0;

							Tracker.trigger(eventNameText, eventData, items);
							this.pushData(eventData);
							if (itemRemoved) {
								var event2CartFilled = Object.assign({}, eventData);

								event2CartFilled['gtm.uniqueEventId'] = ++event2CartFilled['gtm.uniqueEventId'];

								event2CartFilled.event = 'removeFromCart';
								Tracker.trigger('removeFromCart', event2CartFilled);
								self.pushData(event2CartFilled);
							}
							return this;
						}

					},
					trackProceedToCheckout: function (e) {
						var eventName = 'proceedToCheckout';
						var orderModel = LiveOrderModel.getInstance();
						var eventData = {
							event: eventName,
							data: {
								name: "proceedToCheckout",
								category: "Checkout - User Interaction",
								action: "Proceed To Checkout",
								currency: (SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code) ||
									SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl || '',
								value: 0,
								items: [],
								label: e && e.page ? e.page : "/" + Backbone.history.fragment
							}
						};
						var executed = false;
						var datalayerStorage = JSON.parse(localStorage.getItem('datalayer'));
						_.each(orderModel.get('lines').models, function(item, index) {
							var objectItem = convertToItemObj(item.getItem(), item);
							objectItem.index = index;
							objectItem.position = index + 1;
							if (datalayerStorage.cartListRelationship[item.get('internalid')]) {
								objectItem.listId = datalayerStorage.cartListRelationship[item.get('internalid')].listId;
								objectItem.listName = datalayerStorage.cartListRelationship[item.get('internalid')].listName;
							}
							eventData.data.items.push(objectItem);
							eventData.data.value += objectItem.amount;
						});
						_.each(orderModel.get('promocodes'), function(promo) {
							eventData.data.coupon = promo.code;
						});
						if (!localStorage.getItem('proceedToCheckoutUniqueId')) {
							setCartId(orderModel);
						}
						if (!executed) {
							var uniqueTs = localStorage.getItem('proceedToCheckoutUniqueId');
							executed = true;
							if (uniqueTs) {
								eventData.data.cartId = uniqueTs.toString();
							}
						}
						Tracker.trigger(eventName, eventData, eventData.data);
						this.pushData(eventData);
						localStorage.setItem('originIsProceedToCheckout', 'T');
						return this;
					},
					trackProductListGeneric: function (eventName, items, listName) {
						var self = this;
						var total, id;
						var listId, eventData;
						var model, imageUrl;
						var promise = jQuery.Deferred();
						if (listName === 'Related Items' || listName === 'Correlated Items' || listName === 'Recently Viewed Items') {
							listId = listName.split(' ').join('_').toLowerCase();
							promise.resolve();
						} else
						if (plp.current_view) {
							model = plp.current_view.model;
							total = model.get('total');
							id = model.get('category') && model.get('category').id
							var dataLayerModel = new DataLayerModel();
							dataLayerModel.fetch({
								data: {
									commercecategoryid: id
								}
							}).then(function (result) {
								if (result.data) {
									var baseUrl = window.location.protocol + '//' + window.location.hostname;
									imageUrl = baseUrl + '/' + result.data.replace('Web Site Hosting Files/','').replace('Live Hosting Files/','');
								}
								promise.resolve();
							})
							
							listId = plp.getCategoryInfo() ? plp.getCategoryInfo().urlfragment : 'search_results';
							if (listName === 'Category' && !plp.getCategoryInfo()) {
								listName = 'Search Results';
							}
						} else {
							listId = listName.split(' ').join('_').toLowerCase();
							promise.resolve();
						}
						listId = listId.split('-').join('_');

						if (eventName === 'productList') {
							listName = listId.split('_').map(function (word) {
								return word.charAt(0).toUpperCase() + word.slice(1);
							});
							listName = listName.join(' ');
							if (total) {
								listName = model && model.get('category') && model.get('category').get('name') || 'Search Results';
								listId = listName.split(' ').join('_').toLowerCase();
							}
							storeLastSeen(listId, listName);
						}
						eventData = {
							event: eventName,
							ecommerce: {
								listId: listId,
								listName: listName,
								currencyCode: (SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code) ||
									SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl || '',
								impressions: []
							},
							page: self.getCategory(),
							list: listName,
							label: listName,
							url: window.location.href
						};

						if (id) {
							eventData.id = id;
						}
						if (total) {
							eventData.results = total;
							eventData.name = model && model.get('category') && model.get('category').get('name') || 'search'
						}
						promise.done(function () {
							if (imageUrl) {
								eventData.imageUrl = imageUrl;
							}
							updateProductListItems(items, eventData, listName, self);
							Tracker.trigger(eventName, eventData, items);
							self.pushData(eventData);
						});
						return this;
					},
					trackAddToWishlist: function(line) {
						if (line) {
							var item = line.get('item');
							var objectItem = convertToItemObj(item, line);
							var datalayerStorage = JSON.parse(localStorage.getItem('datalayer'));
							objectItem.listId = datalayerStorage.lastListSeen.listId;
							objectItem.listName = datalayerStorage.lastListSeen.listName;
							objectItem.list = objectItem.listName;
							objectItem.position = 1;
							objectItem.index = 0;

							var eventName = 'addToWishlist';
							var valueAux = objectItem.price * objectItem.quantity;
							var eventData = {
								event: eventName,
								data: {
									action: 'Add To Wishlist',
									currencyCode: (SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code) ||
										SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl || '',
									value: parseFloat(valueAux.toFixed(2)),
									products: [
										objectItem
									]
								}
							};
							Tracker.trigger(eventName, eventData, line);
							this.pushData(eventData);
						}
						return this;
					},
					trackSearchResults: function (items, keyword) {
						var eventData = {
							event: 'searchResults',
							data: {
								currencyCode: (SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code) ||
									SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl || '',
								page: this.getCategory(),
								list: 'searchResults',
								show: plp.getPageSize() && plp.getPageSize().items,
								order: plp.getSorting() && plp.getSorting().id,
								display: plp.getDisplay() && plp.getDisplay().id,
								label: 'Search Results',
								items: [],
								keywords: keyword
							}
						};

						if (keyword === true) {
							delete eventData.data.keywords;
						}
						var i = 1;
						_.each(plp.getFilters(), function(filter) {
							if (i === 1 && !eventData.data['customParameter']) {
								eventData.data['customParameter'] = filter.value;
							} else if (i <= plp.getFilters().length) {
								eventData.data['customParameter'+i] = filter.value;
							}
							i++;
						});

						_.each(items.models, function(item, index) {
							var objectItem = convertToItemObj(item, item);
							objectItem.listId = 'search_results';
							objectItem.listName = 'Search Results';
							objectItem.list = 'searchResults';
							objectItem.quantity = item.get('minimumquantity') || 1;
							eventData.data.items.push(objectItem);
						});

						Tracker.trigger('searchResults', eventData, items);
						this.pushData(eventData);

						return this;
					},
					trackPageview: function (url) {
						var self = this;
						if (_.isString(url)) {
							if (SC.ENVIRONMENT.SCTouchpoint === 'myaccount') {
								pushPageViewEvent(url, document.title, 'My Account', self);
								return;
							}
							if (url === '/') {
								pushPageViewEvent(url, document.title, 'Home', self);
								return;
							}
							var foundCMSLanding = _.find(SC.ENVIRONMENT.CMS.pages.pages, function(page) {
								return url.replace('/','') === page.url;
							});

							if (foundCMSLanding) {
								pushPageViewEvent(url, foundCMSLanding.page_header || foundCMSLanding.name, 'Informational Page', self);
								return;
							}

							if (plp && plp.current_view) {
								var model = plp.current_view.model;
								if (model.get('category')) {
									if (model.get('category').get('canonical') === url.split('?')[0]) {
										var categoryGroup = self.getCategoryGroup(model.get('category').get('parenturl'));
										pushPageViewEvent(url, model.get('category').get('name'), categoryGroup || model.get('category').get('name'), self);
									} else {
										self.gettingPDPComponent().done(function () {
											var item = pdp.getItemInfo();
											var group = '';
											var primaryPath = item.item.commercecategory.primarypath;
											if (primaryPath && primaryPath.length > 0) {
												primaryPath.forEach(function (category) {
													group = category.name;
												});
											} else {
												group = self.getItemGroup(item.item.commercecategory.categories);
											}
											pushPageViewEvent(url, item && item.item.itemid, group || 'Uncategorized', self);
										});
									}
								} else {
									pushPageViewEvent(url, document.title, 'Search', self);
								}
							} else {
								self.gettingPDPComponent().done(function () {
									var item = pdp.getItemInfo();
									var group = '';
									if (window.location.href.indexOf(item.item.urlcomponent) > -1) {
										var primaryPath = item.item.commercecategory.primarypath;
										if (primaryPath && primaryPath.length > 0) {
											primaryPath.forEach(function (category) {
												group = category.name;
											});
										} else {
											group = self.getItemGroup(item.item.commercecategory.categories);
										}
										pushPageViewEvent(url, item && item.item.itemid, group || 'Uncategorized', self);
									} else {
										pushPageViewEvent(url, document.title, document.title, self);
									}
								}).fail(function(){
									var triggeredPVE = false;
									if (CMS) {
										CMS.on('page:content:set', function(_promise, _ccts, contentContext) {
											pushPageViewEvent(url, document.title, contentContext.page_type_display_name, self);
											triggeredPVE = true;
										});

										setTimeout(function() {
											var group = document.title;
											if (SC.ENVIRONMENT.SCTouchpoint === 'checkout') {
												group = window.location.href.indexOf('login-register') > -1 ? group : 'Checkout';
											}
											!triggeredPVE && pushPageViewEvent(url, document.title, group, self);
										}, 1000);
									} else {
										pushPageViewEvent(url, document.title, '', self);
									}
								});
							}
						}

						return this;
					},
					findCategoryAndListInDataLayer: function (product) {
						var productSku =
							(product.get('item') && product.get('item').get('_name')) || product.get('id');
						if (productSku) {
							var productClick = _.find(dataLayer, function(obj) {
								return (
									obj.event === 'productClick' &&
									obj.ecommerce &&
									obj.ecommerce.click &&
									obj.ecommerce.click.products &&
									productSku.indexOf(obj.ecommerce.click.products[0].id) === 0
								);
							});
			
							return {
								category:
									(productClick && productClick.ecommerce.click.products[0].category) || '',
								list: (productClick && productClick.ecommerce.click.actionField.list) || ''
							};
						}
					},
					getItemGroup: function (categories) {
						var categoriesGroups = SC.CATEGORIES.length > 1 ? SC.CATEGORIES : SC.CATEGORIES[0].categories;
						if (categories[0] && categories[0].id) {
							var itemCategoryId = categories[0].id;
							window.parentItem = null;
							searchInArray(categoriesGroups, itemCategoryId);
							return window.parentItem && window.parentItem.name;
						} else {
							return ""; // The item is not in a category, return empty string to avoid sending "undefined" to GTM
						}
					},
					getCategoryGroup: function (parentUrlCategory) {
						var quantityOfLevelsAbove = parentUrlCategory.split('/').length - 1;
						var firstCategUrl = '/' + parentUrlCategory.split('/')[1];
						var firstCategory = _.find(SC.CATEGORIES, function(category) { return category.fullurl === firstCategUrl});
						var followingCategory;
						if (quantityOfLevelsAbove > 2) {
							// DEBUG: a logic is required here to show only 1st grouping categ.
							followingCategory = firstCategory && _.find(firstCategory.categories, function(category) { return category.fullurl === firstCategUrl + '/' + parentUrlCategory.split('/')[2]});
						} else {
							followingCategory = firstCategory && _.find(firstCategory.categories, function(category) { return category.fullurl === parentUrlCategory});
						}
						return followingCategory && followingCategory.name || '';
					},
					gettingPDPComponent: function () {
						var promise = jQuery.Deferred();
						pdp && pdp.getItemInfo() && promise.resolve();
						if (!pdp || !pdp.getItemInfo()) {
							var iteration = 0, runPDP = setInterval(function () {
								iteration++;
								if (pdp && pdp.getItemInfo()) {
									clearInterval(runPDP);
									promise.resolve();
								}
								iteration > 20 && promise.reject();
							}, 100);
						}
						return promise;
					}
				});

				Tracker.prototype.trackProductList = function(items, listName) {
					var options = _.parseUrlOptions(location.search);
					if (location.pathname.indexOf('shopping-local.ssp') > -1) {
						options = _.parseUrlOptions(location.hash);
					}
					var key = options.keywords || listName === 'Facets' || '';
					// a Fix required to trigger the track search results
					if (listName === 'Search') {
						listName = 'Search Results';
					}
					listName = (key ? 'Search Results' : 'Category') || listName;
					
					if (listName === 'Search Results') {
						this.trackSearchResults(items, key);
					}
				
					return this.track('trackProductList', items, listName);
				};

				cart.on('afterUpdateLine', function onAfterUpdateLine(lineUpdated) {
					var foundLine = _.find(window.cartLines, function (line) {
						return line.get('internalid') === lineUpdated.line.internalid;
					});
					var lineToSearch;

					if (!foundLine) {
						// we have an issue trying to get the correct line, so we have to check for set.
						var orderModel = LiveOrderModel.getInstance();
						window.cartLines = orderModel.get('lines').models;
						lineToSearch = lineUpdated.line.internalid;
						var splittedSet = Number(lineToSearch.split('set')[1]) + 1;

						lineToSearch = lineToSearch.split('set')[0] + 'set' + splittedSet;
					}
					GoogleTagManager.trackCartUpdate(lineUpdated, false, lineToSearch);
				});
				cart.on('afterRemoveLine', function onAfterRemoveLine(lineUpdated) {
					GoogleTagManager.trackCartUpdate(lineUpdated, true);
					// when removing process so we don't lose references
					window.cartLines = window.cartLines.filter(function (line) {
						return line.get('internalid') !== lineUpdated.line_id;
					});

					var quantityObj = {};
					window.cartLines.forEach(function (line, index) {
						var item = line.get('item');
						var quantity = line.get('quantity');
						var positionInternalId = item.id + '-' + index;

						quantityObj[positionInternalId] = quantity;
					});
					window.quantityItems = quantityObj;
				});
				cart.on('beforeUpdateLine', function () {
					window.cartLinesBefore = LiveOrderModel.getInstance().get('lines').models;
				});
				cart.on('beforeAddLine', function (line) {
					var isPDPFull = jQuery('#ProductDetails\\.Full\\.View').length;
					var isPDPQuick = jQuery('#modal-ProductDetails\\.QuickView\\.View').length;
					window.isQuickAdd = isPDPQuick && !isPDPFull;
					window.itemQuantity = line.line.quantity;
					window.cartLinesBefore = LiveOrderModel.getInstance().get('lines').models;
				});
			}
		};
	});

